module.exports = __webpack_public_path__ + "static/media/yinhuanjubao.5181aaf.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/yinhuanjubao.mp3
// module id = 8u47
// module chunks = 208